import { api } from "utils/api";
import { useMutation, useQuery, useQueryClient } from "react-query";
import type { Ticket } from "../types";

const getTicketsByStatus = (status: string) =>
  api.get<Ticket[]>(`/admin/tickets/list/${status}`);

const getTicketById = (projectReportId: string) =>
  api.get<Ticket>(`/admin/tickets/${projectReportId}`);

const putTicketUpdate = async (
  projectReportId: string,
  status: string,
  notes: string
) =>
  api.put(`/admin/tickets/${projectReportId}`, {
    body: JSON.stringify({ status, notes }),
  });

const useTicketsByStatus = (status: string) =>
  useQuery(["admin-project-reports", status], () => getTicketsByStatus(status));

const useTicketById = (projectReportId: string) =>
  useQuery(["admin-project-reports", projectReportId], () =>
    getTicketById(projectReportId)
  );

const useTicketUpdate = (id?: string, status?: string, notes?: string) => {
  const queryClient = useQueryClient();
  const { mutate: updateTicket } = useMutation(
    () => putTicketUpdate(id as string, status as string, notes as string),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["admin-project-reports", id]);
      },
    }
  );
  return updateTicket;
};

export { useTicketsByStatus, useTicketById, useTicketUpdate };
